import { atom } from "jotai";

export const cartLengthApiHit: any = atom(0);